import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DistributeVerticalTop"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M18 22.5H6C5.6023 22.4996 5.22101 22.3414 4.9398 22.0602 4.65859 21.779 4.50042 21.3977 4.5 21V18C4.50042 17.6023 4.65859 17.221 4.9398 16.9398 5.22101 16.6586 5.6023 16.5004 6 16.5H18C18.3977 16.5004 18.779 16.6586 19.0602 16.9398 19.3414 17.221 19.4996 17.6023 19.5 18V21C19.4996 21.3977 19.3414 21.779 19.0602 22.0602 18.779 22.3414 18.3977 22.4996 18 22.5zM6 18V21H18V18H6zM22.5 13.5H1.5V15H22.5V13.5zM15 10.5H9C8.6023 10.4996 8.22101 10.3414 7.9398 10.0602 7.65859 9.77899 7.50042 9.3977 7.5 9V6C7.50042 5.6023 7.65859 5.22101 7.9398 4.9398 8.22101 4.65859 8.6023 4.50042 9 4.5H15C15.3977 4.50042 15.779 4.65859 16.0602 4.9398 16.3414 5.22101 16.4996 5.6023 16.5 6V9C16.4996 9.3977 16.3414 9.77899 16.0602 10.0602 15.779 10.3414 15.3977 10.4996 15 10.5zM9 6V9H15V6H9zM22.5 1.5H1.5V3H22.5V1.5z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DistributeVerticalTop.vue"]]);
